// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_REQ_REGISTRAR_SVC, SUC_REQ_REGISTRAR_SVC } from '../../../../utils/strings';

export const useRequestRegistrarService = () => {
  const { submit } = useCreateSubmission(
    RegistrarServiceRequest,
    SUC_REQ_REGISTRAR_SVC,
    ERR_REQ_REGISTRAR_SVC,
  );
  return submit;
};
